import { List, Map, Record } from "immutable";

import { ClassTeacherType } from "./ClassTeacher";

export type ClassEnrollmentType = {
  userId: string;
  timeCreated: string;
  classId: string;
  className: string;
  courseIds: List<string>;
  teacherName: string;
  teachers: Map<string, ClassTeacherType>;
  enrollmentUserIds: List<string>;
  isClassManaged?: boolean | null;
  archived?: boolean | null;
};

export type OptionalClassEnrollmentType = Partial<ClassEnrollmentType>;

const defaultClassEnrollment: ClassEnrollmentType = {
  userId: "",
  timeCreated: "",
  classId: "",
  className: "",
  courseIds: List(),
  teacherName: "",
  teachers: Map<string, ClassTeacherType>(),
  enrollmentUserIds: List(),
  isClassManaged: null,
  archived: null
};

export default class ClassEnrollment extends Record(defaultClassEnrollment) {}
